export default "<p>pending-loan works!</p>\n";